import { Icon } from '@loomhq/lens';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectUserCanEditVideo } from 'selectors/shareVideo';
import { selectHasEnded, selectHasStarted } from 'selectors/videoPlayer';

import './styles.less';

export default ({
  children,
  className,
  icon,
  // eslint-disable-next-line no-unused-vars
  isDisabled,
  isCollapsed,
  showNewExperience = false,
  ...props
}) => {
  const hasStarted = useSelector(selectHasStarted);
  const hasEnded = useSelector(selectHasEnded);
  const userCanEditVideo = useSelector(selectUserCanEditVideo);
  let wrapperClassName = `relative px:small py:small inlineFlex items:center text:small weight:medium ${hasStarted &&
    !hasEnded &&
    'width:full'}`;

  let iconColor = 'white';

  if (showNewExperience && hasStarted && !hasEnded) {
    wrapperClassName += ' new-experience-text-button';
    iconColor = 'body';
  } else {
    wrapperClassName += ' white-text-button';
  }

  if (isCollapsed) {
    wrapperClassName += ' text-button-collapsed';
  }

  if (userCanEditVideo) {
    wrapperClassName += ' owner-border-radius';
  } else {
    wrapperClassName += ' viewer-border-radius';
  }

  return (
    <div className={className}>
      <div className={wrapperClassName} {...props}>
        <div>
          <Icon icon={icon} color={iconColor} className="block" />
        </div>
        <div className="collapsing-button-text overflow:hidden mr:xsmall pr:small">
          {children}
        </div>
        <div className="fading-button-text absolute right:xlarge">
          {children}
        </div>
      </div>
    </div>
  );
};
